import moment from 'moment';
export class JobFormSubmission {
    constructor(json) {
        this.formSubmissionUuid = json.submission_id;
        this.formUuid = json.form_id;
        this.submittedBy = json.submitted_by;
        this.submittedOn = moment.utc(json.submitted_on).local();
    }
}
//# sourceMappingURL=JobFormSubmission.js.map